import React from 'react';

const LivestockIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-10 w-10 text-gray-500">
        <path d="M18.8 6.2a2.4 2.4 0 0 0-3.2-1.2l-2.4 1.1c-.2.1-.2.4 0 .5l6.3 3.2c.2.1.4 0 .5-.2l1.1-2.4c.5-1.1.2-2.5-1.3-3.2Z"></path>
        <path d="m7.4 6.6-2.6 2.6c-.6.6-.6 1.5 0 2.1l8.8 8.8c.6.6 1.5.6 2.1 0l2.6-2.6"></path>
        <path d="m14.5 7.5 5.3 5.3"></path>
        <path d="M5 19H2.1c-.6 0-1.1-.4-1-1L2 15"></path>
        <path d="M12.4 2.4a2.4 2.4 0 0 0-3.2 1.2l-2.4 5.2c-.2.5.1 1.1.6 1.2l6.3 1.2c.5.1 1.1-.1 1.2-.6l2.4-5.2c.5-1.1.2-2.5-1.3-3.2Z"></path>
    </svg>
);

export default LivestockIcon;